// create by nieshu on 2018/11/6
import {biLog} from '@/api/bi.axios'
import ETC from '../config/etc.config'

const BiMixin = {
  // created () {
  //   console.log('混入对象的钩子被调用')
  // }
  methods: {
    biLog(data) {
      biLog({...data, pages: this.$route.path})
    }
  },
  beforeRouteEnter(to, from, next) {
    biLog({eventID: ETC.BI_PAGES[to.name] || '', actionId: '201', eventTypeID: '2', pages: to.path})

    next()
  }
}
export default BiMixin
